import { mapMutations, mapGetters } from "vuex";

export default {
    name: "warning",
    computed: {
        ...mapGetters({
            warningStatus: "setting/warningStatus",
        }),
    },
    methods: {
        ...mapMutations({
            changePopupWarning: "setting/SET_WARNING_STATUS",
        }),
    },
};
